import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked-circle--sprite",
  "use": "checked-circle--sprite-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checked-circle--sprite\">\n<path d=\"M6.99992 0.333313C3.31992 0.333313 0.333252 3.31998 0.333252 6.99998C0.333252 10.68 3.31992 13.6666 6.99992 13.6666C10.6799 13.6666 13.6666 10.68 13.6666 6.99998C13.6666 3.31998 10.6799 0.333313 6.99992 0.333313ZM5.66659 10.3333L2.33325 6.99998L3.27325 6.05998L5.66659 8.44665L10.7266 3.38665L11.6666 4.33331L5.66659 10.3333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol